import React, { useState } from 'react';
import {
  Container,
  Paper,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Alert,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import {
  School,
  AttachMoney,
  MenuBook,
  ExpandMore,
  CheckCircle,
  Download,
  AccountBalance,
  Warning,
  DirectionsBus,
  Restaurant,
  LocalHospital,
  Bed,
} from '@mui/icons-material';

const FeeStructure = () => {
  const [tabValue, setTabValue] = useState(0);

  const secondaryInstallments = [
    {
      level: 'Kidato cha 1 - 4 (Kutwa / Day)',
      total: '1,000,000/=',
      q1: '400,000/=',
      q2: '250,000/=',
      q3: '250,000/=',
      q4: '100,000/=',
      notes: 'Inajumuisha masomo yote ya O-Level na mitihani ya ndani',
    },
    {
      level: 'Kidato cha 1 - 4 (Bweni / Boarding)',
      total: '1,400,000/=',
      q1: '500,000/=',
      q2: '400,000/=',
      q3: '300,000/=',
      q4: '300,000/=',
      notes: 'Inajumuisha malazi (hostel) na chakula kamili',
    },
    {
      level: 'Kidato cha 5 & 6 (Kutwa / Day)',
      total: '1,200,000/=',
      q1: '400,000/=',
      q2: '350,000/=',
      q3: '350,000/=',
      q4: '100,000/=',
      notes: 'Combinations: PCM, PCB, PGM, EGM, HGE, HGK, HKL, HGL, HGFa, ICT',
    },
    {
      level: 'Kidato cha 5 & 6 (Bweni / Boarding)',
      total: '1,600,000/=',
      q1: '500,000/=',
      q2: '400,000/=',
      q3: '350,000/=',
      q4: '350,000/=',
      notes: 'Inajumuisha malazi (hostel), chakula kamili & maabara za kisasa',
    },
    {
      level: 'Pre-Form One (Miezi 3 - 12/09 hadi 20/12)',
      total: 'Kutwa: 150,000/= | Bweni: 200,000/=',
      q1: 'Malipo ya mara moja mwanzoni',
      q2: '-',
      q3: '-',
      q4: '-',
      notes: 'Maandalizi maalum ya kujiunga na kidato cha kwanza',
    },
  ];

  const primaryInstallments = [
    {
      level: 'Pre-School / Chekechea (Kutwa)',
      total: '1,000,000/=',
      q1: '350,000/=',
      q2: '350,000/=',
      q3: '200,000/=',
      q4: '100,000/=',
      includes: 'Kifungua kinywa (Breakfast), Chakula cha Mchana (Lunch) na Usafiri wa Shule (School Bus)',
    },
    {
      level: 'Darasa la 1 - 6 (Kutwa / Day)',
      total: '1,000,000/=',
      q1: '350,000/=',
      q2: '350,000/=',
      q3: '200,000/=',
      q4: '100,000/=',
      includes: 'Kifungua kinywa (Breakfast), Chakula cha Mchana (Lunch) na Usafiri wa Shule (School Bus)',
    },
    {
      level: 'Darasa la 1 - 6 (Bweni / Boarding)',
      total: '1,400,000/=',
      q1: '500,000/=',
      q2: '500,000/=',
      q3: '300,000/=',
      q4: '100,000/=',
      includes: 'Malazi ya Hostel, Huduma ya Afya, na Chakula Chote (Full Meals)',
    },
  ];

  const examFeesList = [
    {
      exam: 'Kidato cha Pili (FTNA)',
      breakdown: [
        { name: 'Mitihani ya Taifa (FTNA)', fee: '20,000/=' },
        { name: 'Mitihani ya Mock Kidato cha Pili', fee: '20,000/=' },
        { name: 'Mitihani ya Wilaya', fee: '20,000/=' },
      ],
      total: '60,000/=',
    },
    {
      exam: 'Kidato cha Nne (CSEE)',
      breakdown: [
        { name: 'Mitihani ya Taifa (CSEE)', fee: '60,000/=' },
        { name: 'Mitihani ya Mock Kidato cha Nne', fee: '20,000/=' },
        { name: 'Mitihani ya Wilaya', fee: '20,000/=' },
      ],
      total: '100,000/=',
    },
    {
      exam: 'Kidato cha Sita (ACSEE)',
      breakdown: [
        { name: 'Mitihani ya Taifa (ACSEE)', fee: '80,000/=' },
        { name: 'Mitihani ya Mock Kidato cha Sita', fee: '20,000/=' },
        { name: 'Mitihani ya Wilaya', fee: '20,000/=' },
      ],
      total: '120,000/=',
    },
  ];

  const secSupplies = [
    { item: 'Faili za kitaaluma (3)', cost: '15,000/=' },
    { item: 'Michezo na burudani', cost: '10,000/=' },
    { item: 'T-Shirt za shule (2)', cost: '40,000/=' },
    { item: 'Kitambulisho cha mwanafunzi (ID Card)', cost: '10,000/=' },
    { item: 'Mashati meupe ya shule (2)', cost: '40,000/=' },
    { item: 'Sweta la shule (1)', cost: '20,000/=' },
    { item: 'Pesa ya tahadhari (Caution money)', cost: '20,000/=' },
    { item: 'Ndoo ndogo (2)', cost: '10,000/=' },
    { item: 'Pesa ya matibabu na dawa', cost: '60,000/=' },
    { item: 'Track suit ya shule (1)', cost: '20,000/=' },
    { item: 'Sketi / Suruali rangi nyeusi (2)', cost: '60,000/=' },
    { item: 'Suruali / Sketi rangi ya ugoro (2)', cost: '60,000/=' },
    { item: 'Ream za karatasi (2)', cost: '30,000/=' },
    { item: 'Jezi za michezo (2)', cost: '40,000/=' },
    { item: 'Godoro kwa wanafunzi wa bweni (1)', cost: '100,000/=' },
    { item: 'Kunyoa nywele kwa mwaka', cost: '40,000/=' },
  ];

  const primarySupplies = [
    { item: 'Registration (Usajili)', cost: '20,000/=' },
    { item: 'Uniform (Mashati 2, sweta 1, t-shirt kijani 2, tracksuit 2)', cost: '150,000/=' },
    { item: 'Kaptula 4 au sketi 4 za kushona shuleni', cost: '90,000/=' },
    { item: 'Kitambulisho cha mwanafunzi', cost: '10,000/=' },
    { item: 'Matibabu (Wanafunzi wa bweni)', cost: '70,000/=' },
    { item: 'Diary ya shule', cost: '10,000/=' },
    { item: 'Stationary na karatasi', cost: '60,000/=' },
    { item: 'Files (3)', cost: '15,000/=' },
    { item: 'Godoro (2.5x4x6) kwa wanafunzi wa bweni', cost: '100,000/=' },
    { item: 'Kunyolewa nywele (miezi 10 @2,000) bweni', cost: '20,000/=' },
  ];

  return (
    <Box sx={{ bgcolor: '#f4f7fb', minHeight: '100vh', py: { xs: 3, md: 6 } }}>
      <Container maxWidth="lg">
        {/* Header */}
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, md: 5 },
            borderRadius: 4,
            background: 'linear-gradient(135deg, #1a237e 0%, #0d47a1 100%)',
            color: 'white',
            textAlign: 'center',
            mb: 4,
            boxShadow: '0 10px 30px rgba(26,35,126,0.2)',
          }}
        >
          <Chip label="Academic Year 2026" sx={{ bgcolor: '#ffd700', color: '#0a0a2a', fontWeight: 800, mb: 2 }} />
          <Typography variant="h3" sx={{ fontWeight: 900, fontSize: { xs: '1.8rem', md: '2.8rem' }, mb: 1 }}>
            Ratiba Rasmi ya Ada na Mahitaji ya Shule
          </Typography>
          <Typography variant="h6" sx={{ color: 'rgba(255,255,255,0.9)', fontWeight: 400, maxWidth: 750, mx: 'auto', mb: 3 }}>
            Kaozya High School (Reg: S.4913) &amp; Kaozya English Medium School (Reg: EM.21666)
          </Typography>

          {/* Quick PDF downloads */}
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              href="/downloads/FOMU_YA_KUJIUNGA_NA_KAOZYA_HIGH_SCHOOL.pdf"
              download="FOMU_YA_KUJIUNGA_NA_KAOZYA_HIGH_SCHOOL.pdf"
              startIcon={<Download />}
              sx={{
                bgcolor: '#ff6f00',
                color: 'white',
                fontWeight: 700,
                textTransform: 'none',
                borderRadius: 2,
                px: 3,
                '&:hover': { bgcolor: '#e65100' },
              }}
            >
              Download Fomu ya High School (PDF)
            </Button>
            <Button
              variant="contained"
              href="/downloads/FOMU_YA_KUJIUNGA_NA_KAOZYA_ENGLISH_MEDIUM.pdf"
              download="FOMU_YA_KUJIUNGA_NA_KAOZYA_ENGLISH_MEDIUM.pdf"
              startIcon={<Download />}
              sx={{
                bgcolor: '#2e7d32',
                color: 'white',
                fontWeight: 700,
                textTransform: 'none',
                borderRadius: 2,
                px: 3,
                '&:hover': { bgcolor: '#1b5e20' },
              }}
            >
              Download Fomu ya English Medium (PDF)
            </Button>
          </Box>
        </Paper>

        {/* Bank Account Details Banner */}
        <Paper sx={{ p: 3, borderRadius: 3, mb: 4, bgcolor: '#fff', border: '2px solid #1a237e15', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
            <AccountBalance sx={{ color: '#1a237e', fontSize: 32 }} />
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 800, color: '#1a237e' }}>
                Akaunti Rasmi za Benki kwa Malipo Yote (Official Bank Accounts)
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Malipo yote ya ada na vifaa vya shule yafanyike kupitia akaunti hizi za benki pekee:
              </Typography>
            </Box>
          </Box>

          <Grid container spacing={3}>
            {/* Secondary Account */}
            <Grid item xs={12} md={6}>
              <Box sx={{ p: 2.5, bgcolor: '#e8f0fe', borderRadius: 2, border: '1px solid #bfdbfe' }}>
                <Chip label="Kaozya Secondary &amp; High School" size="small" sx={{ bgcolor: '#1a237e', color: 'white', fontWeight: 700, mb: 1 }} />
                <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a237e' }}>
                  CRDB Bank: <strong>0150270576600</strong>
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a237e' }}>
                  NMB Bank: <strong>24410021219</strong>
                </Typography>
                <Typography variant="body2" sx={{ color: '#334155', mt: 0.5 }}>
                  Jina la Akaunti: <strong>KAOZYA HIGH SCHOOL</strong>
                </Typography>
              </Box>
            </Grid>

            {/* Primary Account */}
            <Grid item xs={12} md={6}>
              <Box sx={{ p: 2.5, bgcolor: '#f0fdf4', borderRadius: 2, border: '1px solid #bbf7d0' }}>
                <Chip label="Kaozya English Medium School" size="small" sx={{ bgcolor: '#2e7d32', color: 'white', fontWeight: 700, mb: 1 }} />
                <Typography variant="body1" sx={{ fontWeight: 700, color: '#2e7d32' }}>
                  CRDB Bank: <strong>10323210565</strong>
                </Typography>
                <Typography variant="body2" sx={{ color: '#334155', mt: 0.5 }}>
                  Jina la Akaunti: <strong>KAOZYA ENGLISH MEDIUM SCHOOL</strong>
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Alert severity="error" sx={{ mt: 2, borderRadius: 2 }}>
            <strong>ANGALIZO MUHIMU:</strong> Malipo yasifanyike kwa miamala ya simu (M-Pesa, Tigopesa, Airtel Money, Halopesa). Hairuhusiwi kulipa pesa ya ada au vifaa kwa mfanyakazi yeyote au kuja nayo taslimu (cash) shuleni. Fedha zote zilipwe benki!
          </Alert>
        </Paper>

        {/* Tabs */}
        <Paper sx={{ borderRadius: 3, mb: 4, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
          <Tabs
            value={tabValue}
            onChange={(_, val) => setTabValue(val)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              bgcolor: '#fff',
              borderBottom: '1px solid rgba(0,0,0,0.08)',
              '& .MuiTab-root': { fontWeight: 800, textTransform: 'none', fontSize: '0.95rem', py: 2 },
              '& .Mui-selected': { color: '#1a237e' },
              '& .MuiTabs-indicator': { bgcolor: '#ff6f00', height: 3 },
            }}
          >
            <Tab icon={<School />} iconPosition="start" label="Secondary (Form 1 - 6)" />
            <Tab icon={<DirectionsBus />} iconPosition="start" label="English Medium Primary" />
            <Tab icon={<MenuBook />} iconPosition="start" label="Mitihani ya Taifa &amp; Mock" />
            <Tab icon={<AttachMoney />} iconPosition="start" label="Vifaa &amp; Sare za Shule" />
          </Tabs>

          {/* TAB 0: Secondary School */}
          {tabValue === 0 && (
            <Box sx={{ p: { xs: 2.5, md: 4 } }}>
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ fontWeight: 800, color: '#1a237e', mb: 0.5 }}>
                  Mgawanyo wa Ada ya Secondary &amp; High School (Awamu Nne)
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Ada inalipwa kwa awamu 4 (January-March, April-June, July-September, September-December)
                </Typography>
              </Box>

              <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #e2e8f0', borderRadius: 2, mb: 3 }}>
                <Table>
                  <TableHead sx={{ bgcolor: '#1a237e' }}>
                    <TableRow>
                      <TableCell sx={{ color: 'white', fontWeight: 800 }}>Ngazi ya Elimu</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 800 }}>Jumla kwa Mwaka</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 800 }}>Jan - March</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 800 }}>April - June</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 800 }}>July - Sept</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 800 }}>Sept - Dec</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {secondaryInstallments.map((row, idx) => (
                      <TableRow key={idx} sx={{ '&:nth-of-type(even)': { bgcolor: '#f8fafc' } }}>
                        <TableCell sx={{ fontWeight: 700 }}>
                          {row.level}
                          <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary' }}>
                            {row.notes}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ fontWeight: 900, color: '#ff6f00', fontSize: '1rem' }}>{row.total}</TableCell>
                        <TableCell>{row.q1}</TableCell>
                        <TableCell>{row.q2}</TableCell>
                        <TableCell>{row.q3}</TableCell>
                        <TableCell>{row.q4}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Card sx={{ bgcolor: '#e8f0fe', borderRadius: 3, border: '1px solid #bfdbfe' }}>
                    <CardContent>
                      <Typography variant="h6" sx={{ fontWeight: 800, color: '#1a237e', mb: 1 }}>
                        A-Level Combinations (Kidato cha 5 &amp; 6)
                      </Typography>
                      <Typography variant="body2" sx={{ mb: 2 }}>
                        Mwanafunzi awe na ufaulu wa Credit tatu yaani (C) tatu na kuendelea:
                      </Typography>
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.8 }}>
                        {['PCM', 'PCB', 'PGM', 'EGM', 'HGE', 'HGK', 'HKL', 'HGL', 'HGFa', 'ICT'].map(comb => (
                          <Chip key={comb} label={comb} sx={{ bgcolor: '#1a237e', color: 'white', fontWeight: 800 }} />
                        ))}
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Card sx={{ bgcolor: '#fff3e0', borderRadius: 3, border: '1px solid #fed7aa' }}>
                    <CardContent>
                      <Typography variant="h6" sx={{ fontWeight: 800, color: '#c2410c', mb: 1 }}>
                        Kozi &amp; Mafunzo Maalum (Special Programs)
                      </Typography>
                      <Typography variant="body2" sx={{ mb: 1.5 }}>
                        Nafasi zipo pia kwa masomo ya:
                      </Typography>
                      <List dense>
                        {['Pre-Form One (Miezi 3)', 'Pre-Form Five', 'QT (Qualifying Test)', 'Resitters & Private Candidates (PC)', 'Computer Course'].map((prog, i) => (
                          <ListItem key={i} sx={{ py: 0.2 }}>
                            <ListItemIcon sx={{ minWidth: 28 }}><CheckCircle sx={{ color: '#c2410c', fontSize: 18 }} /></ListItemIcon>
                            <ListItemText primary={prog} primaryTypographyProps={{ variant: 'body2', fontWeight: 600 }} />
                          </ListItem>
                        ))}
                      </List>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Box>
          )}

          {/* TAB 1: Primary School */}
          {tabValue === 1 && (
            <Box sx={{ p: { xs: 2.5, md: 4 } }}>
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ fontWeight: 800, color: '#2e7d32', mb: 0.5 }}>
                  Mgawanyo wa Ada ya Kaozya English Medium School
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Pre-School (Baby, Kindergarten, Pre-Unit) &amp; Standard 1 to 6 (English Medium)
                </Typography>
              </Box>

              <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #e2e8f0', borderRadius: 2, mb: 3 }}>
                <Table>
                  <TableHead sx={{ bgcolor: '#2e7d32' }}>
                    <TableRow>
                      <TableCell sx={{ color: 'white', fontWeight: 800 }}>Darasa / Mpango</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 800 }}>Jumla kwa Mwaka</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 800 }}>Jan - March</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 800 }}>April - June</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 800 }}>July - Sept</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 800 }}>Sept - Dec</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {primaryInstallments.map((row, idx) => (
                      <TableRow key={idx} sx={{ '&:nth-of-type(even)': { bgcolor: '#f8fafc' } }}>
                        <TableCell sx={{ fontWeight: 700 }}>
                          {row.level}
                          <Typography variant="caption" sx={{ display: 'block', color: '#15803d', fontWeight: 600 }}>
                            {row.includes}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ fontWeight: 900, color: '#2e7d32', fontSize: '1rem' }}>{row.total}</TableCell>
                        <TableCell>{row.q1}</TableCell>
                        <TableCell>{row.q2}</TableCell>
                        <TableCell>{row.q3}</TableCell>
                        <TableCell>{row.q4}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <Alert severity="success" sx={{ borderRadius: 2 }}>
                <strong>HUDUMA ZINAZOJUMUISHWA:</strong> Kwa wanafunzi wa kutwa, ada inajumuisha <strong>Kifungua Kinywa (Breakfast)</strong>, <strong>Chakula cha Mchana (Lunch)</strong>, na <strong>Usafiri wa Mabasi ya Shule (Free School Bus Transport)</strong>. Kwa wanafunzi wa bweni, inajumuisha malazi na chakula kamili.
              </Alert>
            </Box>
          )}

          {/* TAB 2: Exam Fees */}
          {tabValue === 2 && (
            <Box sx={{ p: { xs: 2.5, md: 4 } }}>
              <Typography variant="h5" sx={{ fontWeight: 800, color: '#1a237e', mb: 1 }}>
                Michango ya Mitihani ya Nje ya Shule &amp; Mock
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Kwa wanafunzi wa Kidato cha Pili, Nne na Sita (Madarasa ya Mitihani ya Taifa)
              </Typography>

              <Grid container spacing={3}>
                {examFeesList.map((exam, idx) => (
                  <Grid item xs={12} md={4} key={idx}>
                    <Card sx={{ height: '100%', borderRadius: 3, border: '2px solid #1a237e20', boxShadow: '0 6px 20px rgba(0,0,0,0.06)' }}>
                      <Box sx={{ p: 2.5, bgcolor: '#1a237e', color: 'white' }}>
                        <Typography variant="h6" sx={{ fontWeight: 800 }}>{exam.exam}</Typography>
                        <Typography variant="h4" sx={{ color: '#ffd700', fontWeight: 900, mt: 1 }}>
                          TSh {exam.total}
                        </Typography>
                      </Box>
                      <CardContent sx={{ p: 2.5 }}>
                        <List dense>
                          {exam.breakdown.map((b, i) => (
                            <ListItem key={i} sx={{ px: 0, py: 1, borderBottom: '1px solid #f1f5f9' }}>
                              <ListItemText primary={b.name} primaryTypographyProps={{ variant: 'body2' }} />
                              <Typography variant="body2" sx={{ fontWeight: 700, color: '#1a237e' }}>{b.fee}</Typography>
                            </ListItem>
                          ))}
                        </List>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}

          {/* TAB 3: Uniforms & Supplies */}
          {tabValue === 3 && (
            <Box sx={{ p: { xs: 2.5, md: 4 } }}>
              <Typography variant="h5" sx={{ fontWeight: 800, color: '#1a237e', mb: 1 }}>
                Mahitaji &amp; Sare Zinazolipwa Shuleni
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Vifaa hivi vinatolewa na shuleni ili kuhakikisha sare na ubora unazingatiwa
              </Typography>

              <Grid container spacing={4}>
                {/* Secondary Supplies */}
                <Grid item xs={12} md={6}>
                  <Card sx={{ borderRadius: 3, border: '1px solid #1a237e25', height: '100%' }}>
                    <Box sx={{ p: 2, bgcolor: '#1a237e', color: 'white' }}>
                      <Typography variant="h6" sx={{ fontWeight: 800 }}>
                        Vifaa vya Secondary (Jumla: TSh 575,000/=)
                      </Typography>
                    </Box>
                    <CardContent sx={{ p: 2.5, maxHeight: 420, overflowY: 'auto' }}>
                      <Table size="small">
                        <TableBody>
                          {secSupplies.map((s, idx) => (
                            <TableRow key={idx}>
                              <TableCell sx={{ py: 0.8 }}>{s.item}</TableCell>
                              <TableCell align="right" sx={{ fontWeight: 700, color: '#1a237e', py: 0.8 }}>{s.cost}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Primary Supplies */}
                <Grid item xs={12} md={6}>
                  <Card sx={{ borderRadius: 3, border: '1px solid #2e7d3225', height: '100%' }}>
                    <Box sx={{ p: 2, bgcolor: '#2e7d32', color: 'white' }}>
                      <Typography variant="h6" sx={{ fontWeight: 800 }}>
                        Vifaa vya Primary (Kutwa: 355k / Bweni: 545k)
                      </Typography>
                    </Box>
                    <CardContent sx={{ p: 2.5, maxHeight: 420, overflowY: 'auto' }}>
                      <Table size="small">
                        <TableBody>
                          {primarySupplies.map((s, idx) => (
                            <TableRow key={idx}>
                              <TableCell sx={{ py: 0.8 }}>{s.item}</TableCell>
                              <TableCell align="right" sx={{ fontWeight: 700, color: '#2e7d32', py: 0.8 }}>{s.cost}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Box>
          )}
        </Paper>
      </Container>
    </Box>
  );
};

export default FeeStructure;
